import {SignUpSendToken} from 'domain/usecases';
import {RemoteSignUpSendToken} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeSignUpSendToken = (): SignUpSendToken =>
	new RemoteSignUpSendToken(
		makeBFFApiUrl(EntryFlowEndPoints.signUpSendToken),
		makeAuthorizeHttpClientDecorator(),
	);
